import React from 'react'
import styled from 'styled-components'
import UploadButton from './UploadButton'
import PropTypes from 'prop-types'

FileUpload.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  fileName: PropTypes.string.isRequired,
  onFileChange: PropTypes.func.isRequired,
}

export default function FileUpload(props) {
  return (
    <FileUploadWrapper>
      <UploadButton
        disabled={props.disabled}
        id="file-upload"
        onFileChange={props.onFileChange}
      >
        {props.children}
      </UploadButton>
      <SelectedFile>
        {props.fileName || 'No File Selected'}
        <Spinner visible={props.disabled} />
      </SelectedFile>
    </FileUploadWrapper>
  )
}

const FileUploadWrapper = styled.div`
  display: flex;
  padding: 0.5em 0;
`

const SelectedFile = styled.label`
  border: solid 1px lightgray;
  padding: 0.5rem 1rem 0.4rem;
  margin: 0;
  flex: auto;
  color: dimgrey;
  position: relative;
`

const Spinner = styled.i.attrs(props => ({
  className: 'fas fa-spinner fa-spin',
}))`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  position: absolute;
  top: calc(50% - 7px);
  right: 10px;
`



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js